<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-card>
                <v-card-title class="primary headline white--text">
                    Plots
                </v-card-title>
                <v-card-text>

                    <equipment-selector v-model="equipment" v-on:ect="equipemntTypeChange($event)"></equipment-selector>
                    <variable-selector :equipment="equipment" v-model="variableX" label="Variable X"></variable-selector>
                    <variable-selector :equipment="equipment" v-model="variableY" label="Variable Y"></variable-selector>
                    <div v-if="isDevelopment">
                        Development Debug
                    {{variableX}}
                    {{variableY}}
                    {{equipment}}
                    {{range}}
                    {{onOnly}}
                    </div>

                    <date-range-selector v-model="range"></date-range-selector>

                    <v-switch
                            v-model="onOnly"
                            label="View Points when Chiller is On"
                    ></v-switch>
                    <v-btn color="primary"
                            @click="exportAll()"
                    >
                        Export all as PDF
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-flex xs12>
            <scatter-plot :variable-x="variableXSensorName"
                          :variable-y="variableYSensorName"
                          :facility_name="facility_name"
                          :equipment_name="equipmentName"
                          :date-range="range"
                          :on-only="onOnly"
                          type="dygraph"
            >
            </scatter-plot>
            <!--Use carnotPower tag instead -->
            <scatter-plot v-if="equipmentType==='chiller'" variable-x="Comp_Power"
                          variable-y="Comp_Power"
                          :facility_name="facility_name"
                          :equipment_name="equipmentName"
                          :date-range="range"
                          :on-only="onOnly"
                          type="dygraph"
            >
            </scatter-plot>
            <scatter-plot v-if="equipmentType==='pump'" variable-x="KW"
                          variable-y="KW"
                          :facility_name="facility_name"
                          :equipment_name="equipmentName"
                          :date-range="range"
                          :on-only="onOnly"
                          type="dygraph"
            >
            </scatter-plot>
            <scatter-plot :variable-x="variableXSensorName"
                          :variable-y="variableYSensorName"
                          :facility_name="facility_name"
                          :equipment_name="equipmentName"
                          :on-only="onOnly"
                          :date-range="range"
            >
            </scatter-plot>
            <scatter-plot
                          :facility_name="facility_name"
                          :equipment_name="equipmentName"
                          :date-range="range"
                          :variable-x="variableXSensorName"
                          :variable-y="variableXSensorName"
                          type="histogram"
                          :on-only="onOnly"
            ></scatter-plot>
        </v-flex>
        <template v-if="maintenanceItem">
            <v-btn small
              fixed
              bottom
              right
              fab
                   @click="maintenanceDialog=true">
                <v-icon>
                    fa-notes-medical
                </v-icon>
            </v-btn>
            <fault-record-dialog v-model="maintenanceDialog" :item="{...maintenanceItem}"></fault-record-dialog>
        </template>
    </v-layout>
</template>

<script>
import DateRangeSelector from '../components/DateRangeSelector'
import ScatterPlot from '../components/ScatterPlot'
import EquipmentSelector from '../components/EquipmentSelector'
import VariableSelector from '../components/VariableSelector'
import _ from 'lodash'
import FaultRecordDialog from '../components/FaultRecordDialog'
import exportAllToPDF from '../components/mixins/exportAllToPDF'
import moment from 'moment'
export default {
  name: 'Sensors',
  components: { FaultRecordDialog, VariableSelector, EquipmentSelector, ScatterPlot, DateRangeSelector },
  mixins:[exportAllToPDF],
  data() {
    return {
      onOnly: false,
        range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
      variableX: {sensor_name: '', facility_name: '', equipment_name: ''},
      variableY: {sensor_name: '', facility_name: '', equipment_name: ''},
      equipment: null,
        highlightTime: null,
        equipmentType:null,
      maintenanceDialog: false
    }
  },

  beforeMount() {
    // popular with query
    let varX = _.get(this.$route.query,'variableX', '')
    let varY = _.get(this.$route.query,'variableY', '')
    this.equipment = _.get(this.$route.query,'equipment', null)
    let rangeStart = _.get(this.$route.query,'rangeStart', this.range.start)
    let rangeEnd =  _.get(this.$route.query,'rangeEnd', this.range.end)
    this.highlightTime =  _.get(this.$route.query,'highlightTime', null)
    this.onOnly = (_.get(this.$route.query, 'onOnly', this.onOnly))
    if(this.onOnly==='true'){
        this.onOnly=true;
    }  else if (this.onOnly==='false'){
        this.onOnly=false;
    }
    this.variableX = {sensor_name: varX, facility_name: this.facility_name, equipment_name: this.equipment}
    this.variableY = {sensor_name: varY, facility_name: this.facility_name, equipment_name: this.equipment}
    this.range = {start: rangeStart, end: rangeEnd}
  },
  methods: {
    updateQueryString () {
      this.$router.replace({
        path: '/sensors',
        query: {
          variableX: _.get(this.variableX, 'sensor_name', null),
          variableY: _.get(this.variableY, 'sensor_name', null),
          equipment: this.equipment,
          rangeStart: this.range.start,
          rangeEnd: this.range.end,
          highlightTime: this.highlightTime,
          onOnly: this.onOnly
        }
      }).catch(err => {})
    },
      equipemntTypeChange(event){
        this.equipmentType=event;
      },
      async exportAll(){
          this.exportAllItems(this.$children);
      }
  },
  computed: {
    variableXSensorName () {
      return _.get(this.variableX, 'sensor_name', null)
    },
    variableYSensorName () {
      return _.get(this.variableY, 'sensor_name', null)
    },
    equipmentName () {
      return _.get(this.variableX, 'equipment_name', null)
    },
    maintenanceItem(){
      return this.$store.state.maintenanceRecordStore.record
    },
    isDevelopment () {
      return process.env.NODE_ENV==='development'
    },
    facility_name () {
      return this.$store.state.pointsListStore.pointsList.facility_name
    }
  },
  watch: {
    onOnly(){ this.updateQueryString()},
    range(){ this.updateQueryString()},
    variableX(){
      this.updateQueryString()
      if (!this.variableY.sensor_name) {
        this.variableY = this.variableX //if variable Y is undefined assign same value and start showing plots
      }
    },
    variableY(){
      this.updateQueryString()
      if (!this.variableX.sensor_name) {
        this.variableX = this.variableY //if variable X is undefined assign same value and start showing plots
      }
    },
    equipment(){
        for (let i in this.$store.state.pointsListStore.pointsList.sensors){
            if (i===this.equipment) {
                if(this.$store.state.pointsListStore.pointsList.sensors[i][0]&&this.$store.state.pointsListStore.pointsList.sensors[i][1]&&!this.variableX||!this.variableX.sensor_name||this.variableX.sensor_name==""){
                    this.variableX={
                        sensor_name: this.$store.state.pointsListStore.pointsList.sensors[i][0],
                        equipment_name: i,
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name
                    }
                    this.variableY={
                        sensor_name: this.$store.state.pointsListStore.pointsList.sensors[i][1],
                        equipment_name: i,
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name
                    }
                }
                break
            }
        }
        this.updateQueryString()
    },
  },
}
</script>

<style scoped>

</style>
